import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { forwardRef } from 'react';
import { Link, LinkProps, Outlet, useLocation } from 'react-router-dom';

type NavTab = {
  name: string;
  path: string;
};

type Props = {
  tabs: NavTab[];
};

const TabLink = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => <Link ref={ref} {...props} />);

const matchTabIndex = (tabs: NavTab[], pathname: string): number => {
  const index = tabs.findIndex((tab) => pathname === tab.path || pathname.startsWith(`${tab.path}/`));
  return index === -1 ? 0 : index;
};

export const NavTabs = ({ tabs }: Props) => {
  const { pathname } = useLocation();
  const activeIndex = matchTabIndex(tabs, pathname);

  return (
    <Box my={1}>
      <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.05)', borderRadius: '8px', width: 'fit-content' }}>
        <Tabs value={activeIndex}>
          {tabs.map((tab) => (
            <Tab key={tab.path} label={tab.name} component={TabLink} to={tab.path} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ p: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
};
